import { useTranslation } from "react-i18next";
import RHFArray from "../fields/RHFArray";
import ProcessStepsBuilder from "../fields/ProcessStepsBuilder";
import { ScopeType } from "types/globalTypes";
import { useMemo, useState } from "react";
import HelpModal from "components/help/HelpModal";
import helpImage from "assets/img/example.png";

interface Props {
  scope: ScopeType;
  isViewMode: boolean;
}

export default function RelationsSection({ scope, isViewMode }: Props) {
  const { t } = useTranslation();
  const [isHelpModalOpen, setIsHelpModalOpen] = useState(false);

  const suppliersFields = useMemo(
    () => [
      {
        name: "supplierName",
        label: t("company.fields.supplierName"),
        type: "text",
        required: true,
        disabled: isViewMode,
        placeholder: t("company.fields.supplierNamePlaceholder"),
      },
      {
        name: "supplierDescription",
        label: t("company.fields.supplierDescription"),
        type: "textarea",
        required: true,
        disabled: isViewMode,
        rows: 2,
        placeholder: t("company.fields.supplierDescriptionPlaceholder"),
      },
    ],
    [isViewMode, t]
  );

  const customersFields = useMemo(
    () => [
      {
        name: "customerName",
        label: t("company.fields.customerName"),
        type: "text",
        required: true,
        disabled: isViewMode,
        placeholder: t("company.fields.customerNamePlaceholder"),
      },
      {
        name: "customerDescription",
        label: t("company.fields.description"),
        type: "textarea",
        required: true,
        disabled: isViewMode,
        rows: 2,
        placeholder: t("company.fields.customerDescriptionPlaceholder"),
      },
    ],
    [isViewMode, t]
  );

  return (
    <div className="space-y-8">
      <RHFArray
        key="suppliers-array"
        name="suppliers"
        label={t("company.fields.suppliers")}
        scope={scope}
        defaultItem={{
          supplierName: "",
          supplierDescription: "",
        }}
        fields={suppliersFields}
        isViewMode={isViewMode}
        type="primary"
        required={true}
        minItems={1}
      />

      <RHFArray
        key="customers-array"
        name="customers"
        label={t("company.fields.customers")}
        scope={scope}
        defaultItem={{
          customerName: "",
          customerDescription: "",
        }}
        fields={customersFields}
        isViewMode={isViewMode}
        type="secondary"
        required={true}
        minItems={1}
      />

      <ProcessStepsBuilder
        key="process-steps-builder"
        scope={scope}
        isViewMode={isViewMode}
        setIsHelpModalOpen={setIsHelpModalOpen}
        required={true}
        minItems={3}
      />

      <HelpModal
        isOpen={isHelpModalOpen}
        onClose={() => setIsHelpModalOpen(false)}
        imageUrl={helpImage}
        title={t("company.processSteps.helpTitle")}
        description={t("company.processSteps.helpDescription")}
      />
    </div>
  );
}
